import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AuthenticationService} from '@services/authentification.service';
import {CityService} from '@services/city.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-logements',
    templateUrl: './logements.component.html',
    styleUrls: ['./logements.component.scss']
})

export class LogementsComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);
    tabs = 'country';
    secteur = '';
    iris = '';

    compare = [];
    displayedColumns: string[] = ['lib', 'quartier', 'secteur', 'ville', 'france'];

    options = {
        tooltip: {
            trigger: 'item',
            formatter: '{b} : {c} ({d} %)'
        },
        calculable: true,
        legend: {
            show: true,
            top: 'bottom',
            left: 'center',
            data: ['1 pièce', '2 pièces', '3 pièces', '4 pièces', '5 pièces et plus']
        }
    };

    data = {
        series: []
    };

    constructor(
        public cityService: CityService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }


    ngOnInit() {
        if (this.favorite.iris != ''
            && this.favorite.ad_city.mapping_quartier_iris != null
            && this.favorite.ad_city.mapping_quartier_iris.quartier != null) {
            this.tabs = 'quartier';
        }
        this.iris = this.favorite.iris;
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            // this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            // this.iris = this.secteur;
            this.displayedColumns = ['lib', 'quartier', 'ville', 'france'];
        }
        if (!this.favorite.ad_city.mapping_quartier_iris || !this.favorite.ad_city.mapping_quartier_iris.quartier) {
            this.displayedColumns = ['lib', 'ville', 'france'];
        }

        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
        this.user = this.authenticationService.currentUser;
    }

    setData() {
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }

        let irisData = null;
        if (this.iris != '' && this.favorite.ad_city.logement_iris && this.favorite.ad_city.logement_iris[this.iris]) {
            irisData = this.favorite.ad_city.logement_iris[this.iris];
        }

        let secteurData = null;
        if (this.secteur != '' && this.favorite.ad_city.logement_gq && this.favorite.ad_city.logement_gq[this.secteur]) {
            secteurData = this.favorite.ad_city.logement_gq[this.secteur];
        }

        let root = this.favorite.ad_city.logement;
        // Donnée absente (ex. payload de partage allégé) -> widget muet, pas de plantage
        if (!root) {
            return;
        }
        if (this.tabs == 'quartier') {
            if (this.secteur == '') {
                // Tout la ville = nothing
            } else if (this.iris.length == 7 && secteurData) {
                root = secteurData;
            } else if (this.iris.length > 7 && irisData) {
                root = irisData;
            }
        }

        this.data = {
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: ['0%', '30%'],
                    bottom: '15%',
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'center',
                        color: 'black',
                        fontSize: 20
                    },
                    color: ['#FFFFFF'],
                    data: [
                        {
                            value: Math.round(root.PL_LOG),
                            name: (Math.round(root.PL_LOG)).toString() + '\nLogements'
                        },

                    ],
                },
                {
                    name: '',
                    type: 'pie',
                    color: ['#67C2EF', '#79C447', '#FABB3D', '#1277AA', '#FF5455'],
                    radius: ['55%', '81%'],
                    bottom: '15%',
                    label: {
                        show: false,
                        position: 'outer',
                        alignTo: 'labelLine',
                        bleedMargin: 5
                    },
                    data: [
                        {value: Math.round(root.T_F1 * root.PL_LOG), name: '1 pièce'},
                        {value: Math.round(root.T_F2 * root.PL_LOG), name: '2 pièces'},
                        {value: Math.round(root.T_F3 * root.PL_LOG), name: '3 pièces'},
                        {value: Math.round(root.T_F4 * root.PL_LOG), name: '4 pièces'},
                        {value: Math.round(root.T_F5 * root.PL_LOG), name: '5 pièces et plus'},
                    ]
                }
            ]
        };

        if (this.deviceService.isMobile()) {
            this.data.series[0].label.fontSize = 18;
        }

        this.compare = [
            {
                'lib': 'Logements',
                'quartier': (irisData != null ? new Intl.NumberFormat('fr-FR').format(irisData.PL_LOG) : '-'),
                'secteur': (secteurData != null ? new Intl.NumberFormat('fr-FR').format(secteurData.PL_LOG) : '-'),
                'ville': new Intl.NumberFormat('fr-FR').format(this.favorite.ad_city.logement.PL_LOG),
                'france': new Intl.NumberFormat('fr-FR').format(this.favorite.ad_city.logement_fr.PL_LOG),
            },
            {
                'lib': '1 pièce',
                'quartier': (irisData != null ? (irisData.T_F1 * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_F1 * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.logement.T_F1 * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.logement_fr.T_F1 * 100).toFixed(1) + ' %',
            },
            {
                'lib': '2 pièces',
                'quartier': (irisData != null ? (irisData.T_F2 * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_F2 * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.logement.T_F2 * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.logement_fr.T_F2 * 100).toFixed(1) + ' %',
            },
            {
                'lib': '3 pièces',
                'quartier': (irisData != null ? (irisData.T_F3 * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_F3 * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.logement.T_F3 * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.logement_fr.T_F3 * 100).toFixed(1) + ' %',
            },
            {
                'lib': '4 pièces',
                'quartier': (irisData != null ? (irisData.T_F4 * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_F4 * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.logement.T_F4 * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.logement_fr.T_F4 * 100).toFixed(1) + ' %',
            },
            {
                'lib': '5 pièces et plus',
                'quartier': (irisData != null ? (irisData.T_F5 * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_F5 * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.logement.T_F5 * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.logement_fr.T_F5 * 100).toFixed(1) + ' %',
            },
        ];
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }
        this.setData();
    }

    toogleTabs(t) {
        this.tabs = t;
        this.setData();
    }
}
